import { render, staticRenderFns } from "./NavegacionAspirante.vue?vue&type=template&id=3fa1e981&scoped=true"
import script from "./NavegacionAspirante.vue?vue&type=script&lang=js"
export * from "./NavegacionAspirante.vue?vue&type=script&lang=js"
import style0 from "./NavegacionAspirante.vue?vue&type=style&index=0&id=3fa1e981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa1e981",
  null
  
)

export default component.exports